import * as React from 'react';

interface Props {
	style?: Object;
}

interface State {
}

export default class MonoComponent extends React.Component<Props, State> {

	render () {
		return <span className='mono' style={this.props.style}>{this.props.children}</span>;
	}
}


// WEBPACK FOOTER //
// ./code/project/pages/components/shared/MonoComponent.tsx